// 9MILLY: stop autoplay <video> elements from downloading/decoding when
// they aren't actually visible. Fixes two confirmed sources of homepage
// jank: (1) the hero section renders one <video> per breakpoint (desktop +
// mobile) and hides the inactive one with CSS display:none, but the native
// `autoplay` attribute ignores CSS visibility, so both were streaming and
// decoding simultaneously; (2) "video" content blocks placed far down the
// page (e.g. the below-the-fold reels block) also carry `autoplay` and
// start streaming immediately on load instead of waiting until scrolled
// near the viewport.
(function () {
  function isRendered(el) {
    return el.offsetParent !== null || el.getClientRects().length > 0;
  }

  function pauseAndUnload(video) {
    video.pause();
    video.removeAttribute('autoplay');
    video.preload = 'none';
    // Cancels any buffering already in flight for this element.
    video.load();
  }

  function resumePlay(video) {
    video.preload = 'metadata';
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function setup() {
    var videos = Array.prototype.slice.call(document.querySelectorAll('video[autoplay]'));
    if (!videos.length) return;

    videos.forEach(function (video) {
      if (!isRendered(video)) {
        pauseAndUnload(video);
      }
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && isRendered(entry.target)) {
            resumePlay(entry.target);
          } else if (!entry.isIntersecting) {
            entry.target.pause();
          }
        });
      },
      { rootMargin: '600px 0px', threshold: 0.01 }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });

    // Handles the hero's desktop/mobile video swap at the 749px breakpoint:
    // the newly-visible one needs an explicit resume, the newly-hidden one
    // should stop decoding even though it stays in the DOM.
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        videos.forEach(function (video) {
          if (isRendered(video)) {
            if (video.paused) resumePlay(video);
          } else if (!video.paused) {
            video.pause();
          }
        });
      }, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
